// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"136f08d5","16":"87370a66","300":"a79aa491","453":"127be8e2","597":"ad90d805","652":"744207f1","890":"92993850","975":"fa8d336c"}[chunkId] + ".chunk.js";
};